import { useState, useEffect } from "react";
import {
  fetchTaxClass,
  fetchCustomerGroup,
  fetchDeviceByCategory,
} from "../../actions/admin/leads";
import { useNavigate } from 'react-router-dom';
import { CreateLead, fetchDefects } from "../../actions/client/devices";
import { toast } from "react-toastify";
import { fetchDevices } from "../../actions/client/devices";
import SelectBar from "../../components/admin/SelectBar";
import plusIcon from "../../utils/assets/plus.svg";
import removeicon from "../../utils/assets/x.svg";
import { referenceData } from "../../constants/stepper";

const AdminCreateLead = () => {
  const [defects, setDefects] = useState([]);
  const [infoType, setInfotype] = useState("imei_no");
  const [taxClass, setTaxClass] = useState([]);
  const [customerGroup, setCustomerGroup] = useState([]);

  const [deviceData, setDeviceData] = useState([]);
  const [leadItems, setLeadItems] = useState([
    {
      category_id: "",
      devices: [],
      defects: [],
      imei_no: "",
      serial: "",
      delivery_type: "",
      brand_id: ""
    },
  ]);

  const [allCategories, setCategories] = useState([]);

  const [CustomerDetails, setCustomerDetails] = useState({
    // customer_group_id: "",
    // tax_class_id: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    address: "",
    zip_code: "",
    city: "",
    state: "",
    country: "",
    message: "test"
  });
  const navigate = useNavigate();


  const handleLeadSubmit = () => {
    const token = localStorage.getItem('token')
    const data = {
      lead_items: [...leadItems],
      ...CustomerDetails,
    };
    CreateLead(data, token).then((res) => {
      if(res.success){
        toast.success("Lead Created Successfully")
        setTimeout(() => {
          navigate('/admin');
        },1000)
      }else{
        toast.error("Oops, Something went wrong")
      }
    })
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = [...leadItems];
    console.log("field", field);
    updatedRows[index][field] = value;
    setLeadItems(updatedRows);
    console.log("leadItems", leadItems);
    if (field == "category_id") {
      getDevicesByCategoryID(value);
    }
  };

  const getDevicesByCategoryID = (id) => {
    if (id) {
      fetchDeviceByCategory(id).then((res) => {
        setDeviceData(res.data);
      });
    }
  };

  const handleDeviceSelect = (index, field, value) => {
    const updatedRows = [...leadItems];
    const BrandData = [...leadItems];

    const deviceObj = deviceData.find((device) => device.id === value);
    const data = [
      {
        id: deviceObj.id,
        title: deviceObj.title,
        category_id: deviceObj.category_id,
      },
    ];
    updatedRows[index][field] = data;
    BrandData[index]["brand_id"] = deviceObj?.brand_id;
    setLeadItems(BrandData);
    setLeadItems(updatedRows);
  };

  const handleDefectSelect = (index, field, value) => {
    const updatedRows = [...leadItems];

    const deviceObj = defects.find((def) => def.id === value);
    const data = [
      {
        id: deviceObj.id,
        title: deviceObj.title,
      },
    ];
    updatedRows[index][field] = data;
    setLeadItems(updatedRows);
  };

  const handleAddRow = () => {
    setLeadItems([
      ...leadItems,
      {
        category_id: "",
        devices: [],
        defects: [],
        imei_no: "",
        serial: "",
        delivery_type: "",
      },
    ]);
  };

  const handleRemoveRow = (index) => {
    if (leadItems.length <= 1) return;

    const updatedRows = [...leadItems];
    updatedRows.splice(index, 1);
    setLeadItems(updatedRows);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetchDefects().then((res) => {
      setDefects(res.data);
    });
    fetchTaxClass(token).then((res) => {
      setTaxClass(res.data);
    });
    fetchCustomerGroup(token).then((res) => {
      setCustomerGroup(res.data);
    });
    fetchDevices(token).then((response) => {
      setCategories(response.data);
    });
  }, []);

  return (
    <form className="bg-light" onSubmit={(e) => {
      e.preventDefault();
      handleLeadSubmit();
    }}>
      <div className="mx-3 mb-4">
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="text-black my-3">Create New Lead</h3>
          <div className="d-flex ">
            <button
            type="submit"
              className="btn  bg-black text-white py-2 px-4 mx-2"
            >
              Create New Lead
            </button>
          </div>
        </div>
        <div className="row d-flex ">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className=" bg-white rounded shadow pb-3">
              <div className="px-3 pt-3 d-flex justify-content-start align-items-center">
                <div className="">
                  <span className=" f-24">Customer Information</span>
                </div>
              </div>
              <div className="px-3">
                <hr className="mt-2" />
              </div>

              <div className="row px-3 d-flex justify-content-center align-items-center">
                {/* <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Customer Group</label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) =>
                      setCustomerDetails({
                        ...CustomerDetails,
                        customer_group_id: e.target.value,
                      })
                    }
                  >
                    <option value="" >Select Customer Group</option>
                    {customerGroup &&
                      customerGroup.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Tax Class</label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) =>
                      setCustomerDetails({
                        ...CustomerDetails,
                        tax_class_id: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Tax Class</option>
                    {taxClass &&
                      taxClass.map((item) => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                </div> */}
                {/* <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Referral Source</label>
                  <select
                    onChange={(e) =>
                      setCustomerDetails({
                        ...CustomerDetails,
                        reference: e.target.value,
                      })
                    }
                    className="form-select"
                    name=""
                    id=""
                  >
                    <option value="">Select Referral Source</option>
                    {referenceData.map((item) => {
                      return (
                        <option value={item.title} key={item.id}>
                          {item.title}
                        </option>
                      );
                    })}
                  </select>
                </div> */}
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">First Name</label>
                  <input
                    type="text"
                    value={CustomerDetails.first_name}
                    onChange={(e) =>
                      setCustomerDetails({
                        ...CustomerDetails,
                        first_name: e.target.value,
                      })
                    }
                    placeholder="Enter First Name"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Last Name</label>
                  <input
                    type="text"
                    value={CustomerDetails.last_name}
                    onChange={(e) =>
                      setCustomerDetails({
                        ...CustomerDetails,
                        last_name: e.target.value,
                      })
                    }
                    required
                    placeholder="Enter Last Name"
                    className="form-control"
                  />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Email</label>
                  <input
                    type="text"
                    value={CustomerDetails.email}
                    onChange={(e) =>
                      setCustomerDetails({
                        ...CustomerDetails,
                        email: e.target.value,
                      })
                    }
                    required
                    placeholder="Enter Email Address"
                    className="form-control"
                  />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Phone Number</label>
                  <input
                    type="text"
                    value={CustomerDetails.phone}
                    onChange={(e) =>
                      setCustomerDetails({
                        ...CustomerDetails,
                        phone: e.target.value,
                      })
                    }
                    required
                    placeholder="Enter Phone Number"
                    className="form-control"
                  />
                </div>

                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Address</label>
                  <input
                    type="text"
                    value={CustomerDetails.address}
                    onChange={(e) => {
                      setCustomerDetails({
                        ...CustomerDetails,
                        address: e.target.value,
                      });
                    }}
                    required
                    placeholder="Enter Address"
                    className="form-control"
                  />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">City</label>
                  <input
                    type="text"
                    value={CustomerDetails.city}
                    onChange={(e) => {
                      setCustomerDetails({
                        ...CustomerDetails,
                        city: e.target.value,
                      });
                    }}
                    required
                    placeholder="Enter City Name"
                    className="form-control"
                  />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">State</label>
                  <input
                    type="text"
                    value={CustomerDetails.state}
                    onChange={(e) => {
                      setCustomerDetails({
                        ...CustomerDetails,
                        state: e.target.value,
                      });
                    }}
                    required
                    placeholder="Enter State Name"
                    className="form-control"
                  />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Country</label>
                  <input
                    type="text"
                    value={CustomerDetails.country}
                    onChange={(e) => {
                      setCustomerDetails({
                        ...CustomerDetails,
                        country: e.target.value,
                      });
                    }}
                    required
                    placeholder="Enter Country Name"
                    className="form-control"
                  />
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                  <label className="form-label ">Zip Code</label>
                  <input
                    type="text"
                    value={CustomerDetails.zip_code}
                    className="form-control"
                    onChange={(e) => {
                      setCustomerDetails({
                        ...CustomerDetails,
                        zip_code: e.target.value,
                      });
                    }}
                    required
                    placeholder="Enter Zip Code"
                  />
                </div>
                
              </div>
            </div>
          </div>
          
        </div>
      </div>

      {/* form-2 */}
      <div className="my-3 mx-4">
        <div className="row rounded shadow border_bg_col overflow-hidden">
          <p className="txt-head bg-black px-3 text-white mb-0  p-2">
            Device Details
          </p>
          <table className="table table-bordered table-striped table-hover mb-0 mt-0">
            <thead>
              <tr className="">
                <td>Repair Category</td>
                <td>Device</td>
                <td>Task</td>
                <td>
                  <select
                    className="border-0"
                    name=""
                    id=""
                    onChange={(e) => setInfotype(e.target.value)}
                  >
                    <option value="imei_no">IMEI No.</option>
                    <option value="serial_no">Serial No.</option>
                  </select>
                </td>
                <td>Type</td>
                <td>Actions</td>
              </tr>
            </thead>
            <tbody>
              {/* {updatedLeadsdata.lead_items
                ? updatedLeadsdata.lead_items.map((item) => {
                    return (
                      <tr className="p-3" key={item.id}>
                        <td>
                          <GeneralSelectBar
                            dataset={allCategories}
                            name={item.category.name}
                            onValueChange={(e) => updateCategorySelection(e)}
                          />
                        </td>
                        <td>
                          <DeviceSelection
                            name={item?.devices[0].title}
                            id={item?.devices[0].category_id}
                            onValueChange={(e) => updateDeviceSelection(e)}
                          />
                          <GeneralSelectBar
                            dataset={allCategories}
                            name={item.category.name}
                            onValueChange={(e) => updateCategorySelection(e)}
                          />
                        </td>
                        <td className="">
                          
                        </td>
                        <td>{item?.color || "-"}</td>
                        <td>

                          {
                            item.imei_no ? ( 
                              <>
                          <InputValue value={item.imei_no} />

                              </>
                            ) : (
                          <InputValue value={item.serial_no} />

                            )
                          }
                        </td>
                        <td>{item?.delivery_type ? toTitleCase(item?.delivery_type) : '-'}</td>
                        <td>{item?.time_from ? item?.time_from : 'N/A'}</td>
                        <td>{item?.time_to ? item?.time_to : 'N/A'}</td>
                        <td>
                          <input   
                            type="text"
                            inputMode="numeric"
                            value={item.lead_value}
                            onChange={(e) => {
                              if (/^\d*\.?\d*$/.test(e.target.value)) {
                                setUpdatedLeadsData((prevState) => ({
                                  ...prevState,
                                  lead_items: prevState.lead_items.map((leadItem) =>
                                    leadItem.id === item.id
                                      ? {
                                          ...leadItem,
                                          lead_value: e.target.value,
                                        }
                                      : leadItem
                                  ),
                                }));
                            }
                            }}
                            className="form-control form-control-sm"
                          />
                        </td>
                        <td>
                          <input type="text" className="form-control form-control-sm" value={item?.tax} readOnly   />
                        </td>
                        <td>Refferal</td>
                      </tr>
                    );
                  })
                : ""} */}
              {leadItems.map((row, index) => {
                return (
                  <tr className="">
                    <td>
                      {allCategories && allCategories.length > 0 && (
                        <SelectBar
                          dataset={allCategories}
                          defaultName="Select Category"
                          handleChange={handleInputChange}
                          index={index}
                          inputName="category_id"
                        />
                      )}
                    </td>
                    <td>
                      {deviceData && (
                        <SelectBar
                          dataset={deviceData}
                          defaultName="Select Device"
                          handleChange={handleDeviceSelect}
                          index={index}
                          inputName="devices"
                        />
                      )}
                    </td>
                    <td>
                      {defects && defects.length > 0 && (
                        <SelectBar
                          dataset={defects}
                          defaultName="Select Defects"
                          handleChange={handleDefectSelect}
                          index={index}
                          inputName="defects"
                        />
                      )}
                    </td>
                    <td>
                      {infoType == "imei_no" ? (
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter IMEI No."
                          onChange={(e) =>
                            handleInputChange(index, "imei_no", e.target.value)
                          }
                        />
                      ) : (
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) =>
                            handleInputChange(index, "serial", e.target.value)
                          }
                          placeholder="Enter Serial No."
                        />
                      )}
                    </td>
                    <td>
                      <select
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "delivery_type",
                            e.target.value
                          )
                        }
                        className="form-select"
                        name=""
                        id=""
                      >
                        <option value="">---Select Type---</option>
                        <option value="mail">Mail</option>
                        <option value="pick_up">Pick up</option>
                        <option value="drop_off">Drop Off</option>
                      </select>
                    </td>
                    <td>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => handleAddRow()}
                      >
                        <img src={plusIcon} width={20} alt="add" />
                      </button>
                      <button
                        className="btn btn-danger btn-sm mx-2"
                        onClick={() => handleRemoveRow(index)}
                      >
                        <img src={removeicon} width={20} alt="remove" />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </form>
  );
};

export default AdminCreateLead;
